import { _ as _createClass, a as _classCallCheck } from '../../createClass-70c51ca1.js';
import isDev from '../../isDev/index.js';

/* eslint-disable no-console */
var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }
  _createClass(Logger, null, [{
    key: "info",
    value: function info(message, style) {
      isDev && console.info(message, style);
    }
  }, {
    key: "success",
    value: function success(message) {
      isDev && console.log("%c ".concat(message), 'color:green');
    }
  }, {
    key: "error",
    value: function error(message) {
      isDev && console.trace(message);
    }
  }, {
    key: "warn",
    value: function warn(message) {
      isDev && console.warn(message);
    }
  }, {
    key: "deprecate",
    value: function deprecate(message) {
      isDev && console.warn('DEPRECATION::: ', message);
    }
  }]);
  return Logger;
}();

export { Logger as default };
//# sourceMappingURL=index.js.map
